import { Component } from '@angular/core';

import { SliderService } from "../../services/slider.service";

@Component({
  selector: 'app-slider',
  standalone: true,
  imports: [],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss'
})
export class SliderComponent {
  sliderImages: string[] = [];

  constructor(private sliderService: SliderService) {
    this.sliderImages = this.sliderService.sliderImages;
  }
}
